import React from "react";
import CLINIC_CONFIG from "../../../config/clinicConfig";
import Button from "../Button/Button";
import { trackPhoneClick, trackSmsClick } from '../../../utils/gtag';

export type ContactCTAButtonsProps = {
  scheduleButtonHref?: string;
  scheduleOpensInNewTab?: boolean;
  smsBody?: string;
  order?: Array<"schedule" | "text" | "call">;
  buttonClassName?: string;
  iconWrapperClassName?: string;
  labelClassName?: string;
  scheduleButtonClassName?: string;
  textButtonClassName?: string;
  callButtonClassName?: string;
  scheduleLabel?: React.ReactNode;
  textLabel?: React.ReactNode;
  callLabel?: React.ReactNode;
};

const ContactCTAButtons: React.FC<ContactCTAButtonsProps> = ({
  scheduleButtonHref = "/book-appointment",
  scheduleOpensInNewTab = false,
  smsBody = "Hello, I would like to schedule an appointment.",
  order = ["schedule", "text", "call"],
  buttonClassName = "btn-custom",
  iconWrapperClassName = "icon-chip",
  labelClassName = "label",
  scheduleButtonClassName,
  textButtonClassName,
  callButtonClassName,
  scheduleLabel = "Schedule Online",
  textLabel = `Text: (${CLINIC_CONFIG.twilioPhoneNumber.slice(1,4)}) ${CLINIC_CONFIG.twilioPhoneNumber.slice(4,7)}-${CLINIC_CONFIG.twilioPhoneNumber.slice(7)}`,
  callLabel = `Call: ${CLINIC_CONFIG.phoneNumber}`,
}) => {
  const scheduleTarget = scheduleOpensInNewTab ? "_blank" : undefined;
  const scheduleRel = scheduleOpensInNewTab ? "noopener noreferrer" : undefined;

  const buttons: Record<"schedule" | "text" | "call", React.ReactNode> = {
    schedule: (
      <Button
        href={scheduleButtonHref}
        target={scheduleTarget}
        rel={scheduleRel}
        ariaLabel="Schedule Online"
        iconClass="bi bi-calendar"
        className={scheduleButtonClassName ?? buttonClassName}
        iconWrapperClassName={iconWrapperClassName}
        labelClassName={labelClassName}
      >
        {scheduleLabel}
      </Button>
    ),
    text: (
      <Button
        href={CLINIC_CONFIG.getSmsLink(smsBody)}
        ariaLabel={`Text (${CLINIC_CONFIG.twilioPhoneNumber.slice(1,4)}) ${CLINIC_CONFIG.twilioPhoneNumber.slice(4,7)}-${CLINIC_CONFIG.twilioPhoneNumber.slice(7)}`}
        iconClass="bi bi-chat-dots"
        className={textButtonClassName ?? buttonClassName}
        iconWrapperClassName={iconWrapperClassName}
        labelClassName={labelClassName}
        onClick={() => trackSmsClick(CLINIC_CONFIG.getSmsLink(smsBody))}
      >
        {textLabel}
      </Button>
    ),
    call: (
      <Button
        href={CLINIC_CONFIG.getTelLink()}
        ariaLabel={`Call ${CLINIC_CONFIG.phoneNumber}`}
        iconClass="bi bi-telephone"
        className={callButtonClassName ?? buttonClassName}
        iconWrapperClassName={iconWrapperClassName}
        labelClassName={labelClassName}
        onClick={() => trackPhoneClick()}
      >
        {callLabel}
      </Button>
    ),
  };

  return (
    <>
      {order.map((key) => (
        <React.Fragment key={key}>{buttons[key]}</React.Fragment>
      ))}
    </>
  );
};

export default ContactCTAButtons;
